import React from "react";
import { SimpleShowLayout, TextField, NumberInput } from "react-admin";

const Tab = (props) => {
  function s(p) {
    return props.side + "." + p;
  }
  return (
    <SimpleShowLayout {...props}>
      <TextField source={s("season.team.name")} />
      <TextField source={s("id")} />
      <TextField source={s("soccer.id")} />
      <NumberInput source={s("soccer.firstHalfGoals")} />
      <NumberInput source={s("soccer.secondHalfGoals")} />
      <NumberInput source={s("soccer.overtimeGoals")} />
      <NumberInput source={s("soccer.overtime2Goals")} />
      <NumberInput source={s("soccer.shootouts")} />
      <NumberInput source={s("soccer.totalGoals")} />
    </SimpleShowLayout>
  );
};

export default Tab;
